exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".photo[data-v-4225451a]{width:100%}.photo-name[data-v-4225451a]{font-weight:700;padding:0 20px}.photo-caption[data-v-4225451a]{padding:0 20px}.photo-fullsize[data-v-4225451a]{position:fixed;top:0;left:0;width:100vw;height:100vh;overflow:auto;background-color:rgba(0,0,0,.5)}.photo-fullsize .photo-fullsize[data-v-4225451a]{display:block;height:100%;width:100%;width:auto;height:auto;position:absolute;top:0;bottom:0;left:0;right:0;margin:auto}", ""]);

// exports
